$(function(){
  $(".cart-menu-close").click(function(){
    //var bodyNum = parseInt($(".product-page-related-products").offset().top);
    var bodyNum = $(".limespot-container").length > 0 ? parseInt($(".limespot-container").offset().top) : parseInt($(".product-page-related-products").offset().top);
    $('html,body').animate({scrollTop:bodyNum}, 400);
  })
})